module.exports = __webpack_public_path__ + "img/FR15930.1be676a5.png";